var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initial)?_c('FarmForm',{attrs:{"initial":_vm.initial},on:{"submitted":function($event){return _vm.$router.push({ name: 'farms.farms.index' });},"cancel":function($event){return _vm.$router.push({name: 'farms.index'})}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }